var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#7CF8C4",
    fillOpacity: 0.19
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.834 28.25L22.834 25",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.166 28.25L27.166 25",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 19.5833H34.75V19.5833C33.5827 19.5833 32.999 19.5833 32.5572 19.8194C32.2084 20.0059 31.9226 20.2916 31.7362 20.6405C31.5 21.0823 31.5 21.6659 31.5 22.8333V29.6666C31.5 31.5522 31.5 32.495 30.9142 33.0808C30.3284 33.6666 29.3856 33.6666 27.5 33.6666H22.5C20.6144 33.6666 19.6716 33.6666 19.0858 33.0808C18.5 32.495 18.5 31.5522 18.5 29.6666V22.8332C18.5 21.6659 18.5 21.0823 18.2638 20.6405C18.0774 20.2916 17.7916 20.0059 17.4428 19.8194C17.001 19.5833 16.4173 19.5833 15.25 19.5833V19.5833Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9065 15.6515C23.03 15.5363 23.302 15.4345 23.6804 15.3619C24.0588 15.2893 24.5224 15.25 24.9993 15.25C25.4763 15.25 25.9399 15.2893 26.3183 15.3619C26.6967 15.4345 26.9687 15.5363 27.0922 15.6515",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trashIcon.8dd3cb2d8200dc54fed7788468399f33.svg";
export { ForwardRef as ReactComponent };